'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.SkeletonListItem = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    0%{\n        opacity: 0.2;\n    }\n    50%{\n        opacity: 0.3;\n    }\n    100%{\n        opacity: 0.2;\n    }\n    '], ['\n    0%{\n        opacity: 0.2;\n    }\n    50%{\n        opacity: 0.3;\n    }\n    100%{\n        opacity: 0.2;\n    }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n  from {\n    transform: scaleX(0.8);\n}\n\nto {\n    transform: scaleX(1);\n  }\n'], ['\n  from {\n    transform: scaleX(0.8);\n}\n\nto {\n    transform: scaleX(1);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: inline-block;\n    width: 100%;\n    background-size: 400% 400%;\n    border-radius: ', ';\n    background: linear-gradient(45deg, ', ');\n    animation: ', ' 4s ease-out infinite;\n    position: relative;\n    padding: .5em;\n    &:not(:last-child){\n        margin-bottom: .3em;\n    }\n    '], ['\n    display: inline-block;\n    width: 100%;\n    background-size: 400% 400%;\n    border-radius: ', ';\n    background: linear-gradient(45deg, ', ');\n    animation: ', ' 4s ease-out infinite;\n    position: relative;\n    padding: .5em;\n    &:not(:last-child){\n        margin-bottom: .3em;\n    }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    transform-origin: left;\n    background: ', ';\n    border-radius: ', ';\n    height: ', 'em; \n    width: ', '%;\n    position: asbolute;\n    animation: ', ' 4s ease-out infinite;\n    animation-direction: alternate;\n\n  &:not(:last-child){\n      margin-bottom: .3em;\n  }\n'], ['\n    transform-origin: left;\n    background: ', ';\n    border-radius: ', ';\n    height: ', 'em; \n    width: ', '%;\n    position: asbolute;\n    animation: ', ' 4s ease-out infinite;\n    animation-direction: alternate;\n\n  &:not(:last-child){\n      margin-bottom: .3em;\n  }\n']);

exports.Skeleton = Skeleton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var gradientAnimation = (0, _styledComponents.keyframes)(_templateObject); // 0%{background-position:14% 0%}
// 50%{background-position:87% 100%}
// 100%{background-position:14% 0%}

var widthAnimation = (0, _styledComponents.keyframes)(_templateObject2);

var SkeletonListItem = exports.SkeletonListItem = _styledComponents2.default.div(_templateObject3, function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor + ', ' + (0, _chromaJs2.default)(theme.textColor).brighten(.4);
}, gradientAnimation);

var SkeletonText = exports.SkeletonText = _styledComponents2.default.div(_templateObject4, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _chromaJs2.default)(theme.textColor).darken(1);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var height = _ref5.height;
  return height;
}, function (_ref6) {
  var width = _ref6.width;
  return width;
}, widthAnimation);

function Skeleton(_ref7) {
  var _ref7$amount = _ref7.amount,
      amount = _ref7$amount === undefined ? 3 : _ref7$amount;
  return Array.from({
    length: amount
  }).map(function (item, i) {
    return _react2.default.createElement(SkeletonListItem, {
      key: i
    }, Array.from({
      length: Math.max(1, Math.round(Math.random() * 3))
    }).map(function (item, i) {
      return _react2.default.createElement(SkeletonText, {
        key: i,
        width: Math.max(30, Math.floor(Math.random() * 100)),
        height: Math.max(2, Math.random() * 3)
      });
    }));
  });
}